import { RootState } from 'app/rootReducer';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { storeMacroVal } from './extraSlice';

export default function MacroInfo(): JSX.Element{
    let extra = useSelector(
        (state: RootState) => state.extraSlice
    )
    let macroList = Array(parseInt(extra["macros"]["amount"])).fill("")
    console.log(extra["macros"]["amount"])
    macroList = macroList.map((val,i) => {
        if (extra["macros"]["values"][i] === null) return ""
        return extra["macros"]["values"][i]
    })
    const dispatch = useDispatch()

    function SaveMacro() {
        dispatch(storeMacroVal(macroList))
        alert('Macros lagret')
    }

    return(
        <div className="mainDiv">
            <h3>Macro/Scene informasjon</h3>
            <ul>
                {macroList.map((v,i) => (
                    <li key={`macro${i}`}>
                        <input type="text" defaultValue={v} onChange={(event) => macroList[i] = event.currentTarget.value} />
                    </li>
                ))}
            </ul>
            <button className="btnSave" onClick={() => SaveMacro()} >Lagre</button>
        </div>
    )
}